import type { HoroscopePrediction } from "../../config/horoscope-content"

/** A life-area prediction: icon, up/down tags, score bar, description. Ported from Horoscope Prediction. */
export function Prediction({ prediction }: { prediction: HoroscopePrediction }) {
  const { Icon, title, percentage, upTag, downTag, description } = prediction
  const pct = Math.min(100, Math.max(0, Math.round(percentage)))

  return (
    <div className="flex w-full flex-col gap-4 px-4 pt-10">
      <div className="flex items-start gap-6">
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <div className="flex items-center gap-2 [&_svg]:size-8">
            <Icon />
            <h3 className="whitespace-nowrap font-display text-2xl font-medium text-purple-light">
              {title}
            </h3>
          </div>
          <div className="flex flex-wrap items-start gap-[5px]">
            <Tag label={upTag} direction="up" />
            <Tag label={downTag} direction="down" />
          </div>
        </div>

        <div className="flex w-[74px] min-w-[74px] flex-col items-center justify-center gap-2 self-stretch rounded-2xl bg-purple-light/10 px-3 py-1.5">
          <span className="whitespace-nowrap font-display text-2xl font-medium text-purple-light">
            {pct}%
          </span>
          <div className="h-2 w-[50px] overflow-hidden rounded-full bg-purple-light/15">
            <div className="h-full overflow-hidden rounded-full" style={{ width: `${pct}%` }}>
              <div className="h-full w-[50px] bg-gradient-to-r from-[#FF537F] via-[#FF9B00] to-[#7FE718]" />
            </div>
          </div>
        </div>
      </div>

      <p className="font-body text-base text-purple-light/70">{description}</p>
    </div>
  )
}

function Tag({ label, direction }: { label: string; direction: "up" | "down" }) {
  const up = direction === "up"
  return (
    <span
      className={`flex items-center gap-2 rounded-[23px] px-3 py-1.5 font-body text-sm ${
        up ? "bg-green/10 text-green" : "bg-peach/10 text-peach"
      }`}
    >
      <span
        className="size-0 border-x-[5px] border-x-transparent"
        style={
          up ? { borderBottom: "8px solid currentColor" } : { borderTop: "8px solid currentColor" }
        }
      />
      {label}
    </span>
  )
}
